module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("农业总产值")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("农业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("176.58 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
    staticClass: "percent"
  }, [_vm._v("8.60%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("牧业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("73.77 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
    staticClass: "percent"
  }, [_vm._v("1.36%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("17.74 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-12.37%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("种植业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("402.98 "), _c('span', [_vm._v("万亩")])]), _vm._v(" "), _c('p', {
    staticClass: "percent"
  }, [_vm._v("11.73%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("畜牧业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("276.32"), _c('span', [_vm._v("万头")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-2.12%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("237600 "), _c('span', [_vm._v("吨")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-8.79%")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07d324e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/center/centerTop/index.vue
// module id = 1924
// module chunks = 2